module.exports = "";


//////////////////
// WEBPACK FOOTER
// ./app/components/dataGrid/data-table-toolbar/floating-filter/floating-filter.html
// module id = 2020
// module chunks = 50